import ShipperCell from './ShipperCell';

export default ShipperCell;
